(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('vv-responsive-hero')) {
  customElements.define('vv-responsive-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.heroMedia) return;
      this.heroMedia = window.matchMedia('(min-width: 768px)');
      this.heroChange = () => this.updateHeroVideo();
      this.heroMedia.addEventListener('change', this.heroChange);
      this.updateHeroVideo();
    }
    updateHeroVideo() {
      const host = this.querySelector('.vv-desktop-video');
      const template = this.querySelector('template[data-desktop-video]');
      if (!host || !template) return;
      if (this.heroMedia.matches) {
        if (!host.querySelector('video')) {
          host.appendChild(template.content.cloneNode(true));
          const video = host.querySelector('video');
          if (video) {
            video.muted = true;

            const fallbackImage = video.querySelector('img');
            if (fallbackImage) {
              fallbackImage.setAttribute('alt', '');
            }

            const playing = video.play();
            if (playing) playing.catch(() => {});
          }
        }
      } else {
        this.clearHeroVideo();
      }
    }
    clearHeroVideo() {
      const host = this.querySelector('.vv-desktop-video');
      if (!host) return;
      const video = host.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        video.load();
      }
      host.replaceChildren();
    }
    disconnectedCallback() {
      if (this.heroMedia) {
        this.heroMedia.removeEventListener('change', this.heroChange);
        this.heroMedia = null;
      }
      this.clearHeroVideo();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
